import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import firebase from "firebase/app";

Vue.config.productionTip = false

var firebaseConfig = {
  apiKey: "AIzaSyBviBDPVO46-XGLjmJatdMVH_VOoGYFJvg",
  authDomain: "taikitchen.firebaseapp.com",
  databaseURL: "https://taikitchen.firebaseio.com",
  projectId: "taikitchen",
  storageBucket: "taikitchen.appspot.com",
  messagingSenderId: "442233983770",
  appId: "1:442233983770:web:a8b3c43130c84e2cd452a3",
  measurementId: "G-YYPSX7HGP0"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

let app;

firebase.auth().onAuthStateChanged(user => {
  console.log("user", user);
  if (!app) {
    app = new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount("#app");
  }
});

